import styled from '@emotion/styled';
import Slider from 'react-slick';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingLeft: 15,
});

export const Slides = styled(Slider)({
  width: '100vw',
  marginTop: 32,
});
